export const subtitlePending = state => ['waiting', 'processing'].includes(state?.status)

export const hasCleanedVideo = video => video?.subtitleRemoval?.status === 'success' && !!video.subtitleRemoval.resultUrl

export const isCleanedVideo = video => hasCleanedVideo(video) && video.subtitleRemoval.selectedVersion === 'cleaned'

export const displayVideoUrl = video => isCleanedVideo(video) ? video.subtitleRemoval.resultUrl : video?.videoUrl

export function readSubtitleMetadata(url) {
  return new Promise((resolve, reject) => {
    const video = document.createElement('video')
    const finish = (error, data) => {
      clearTimeout(timer)
      video.onloadedmetadata = null
      video.onerror = null
      video.removeAttribute('src')
      video.load()
      if (error) reject(error)
      else resolve(data)
    }
    const timer = setTimeout(() => finish(new Error('读取视频参数超时，请稍后重试')), 20000)
    video.preload = 'metadata'
    video.referrerPolicy = 'no-referrer'
    video.onloadedmetadata = () => {
      const width = video.videoWidth
      const height = video.videoHeight
      const duration = Math.ceil(video.duration)
      if (!width || !height || !Number.isFinite(duration) || duration < 1 || duration > 1800) {
        finish(new Error('无法读取视频参数，或视频时长超过 30 分钟'))
      } else if (width * height > 1920 * 1080) {
        finish(new Error('去字幕支持最高 1080p，请在去字幕页面上传并压缩此视频'))
      } else {
        finish(null, { width, height, duration, x1: 0, y1: 0, x2: width, y2: height })
      }
    }
    video.onerror = () => finish(new Error('读取原视频失败，请检查视频是否可以播放'))
    video.src = url
  })
}
